import useIntersectionObserver from 'hooks/common/useIntersectionObserver';
import useLoginCheck from 'hooks/common/useLoginCheck';
import { getNotis } from 'lib/api/service/dashboard';
import { useInfiniteQuery } from 'react-query';

const dateToString = dateData => {
  const year = dateData.getFullYear();
  const month = dateData.getMonth() + 1;
  const date = dateData.getDate();

  return `${year}-${month}-${date}`;
};

const useNotiBox = (errorType, startDate, endDate) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    error,
  } = useInfiniteQuery(
    ['serviceDashboardNotis', errorType, startDate, endDate],
    ({ pageParam }) =>
      getNotis({
        pageParam,
        filter: 1,
        filterValue: errorType,
        startDate: dateToString(startDate),
        endDate: dateToString(endDate),
      }),
    {
      getNextPageParam: lastPage => {
        if (!lastPage.isLast) return lastPage.nextPage;
        return undefined;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );
  useLoginCheck(error?.response, fetchNextPage);

  const onIntersection = entries => {
    const [entry] = entries;
    entry.isIntersecting && fetchNextPage();
  };

  const containerRef = useIntersectionObserver(onIntersection);

  return { data, hasNextPage, isFetchingNextPage, status, error, containerRef };
};

export default useNotiBox;
